/** Shared helpers for directory pages. */

/** Wider content area on large screens (replaces former `max-w-5xl`). */
export const DIRECTORY_PAGE_MAX =
  'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10'

/** Main + sidebar: tops align so the sticky sidebar lines up with the breadcrumb on desktop. */
export const DIRECTORY_MAIN_GRID =
  'lg:grid lg:grid-cols-[minmax(0,1fr)_300px] lg:gap-10 lg:items-start'

/** Right column: stacks below main on small screens; flows with page on lg. */
export const DIRECTORY_SIDEBAR_COL =
  'mt-8 lg:mt-0'

const SMALL_WORDS = new Set(['of', 'and', 'the', 'in', 'on', 'at', 'for', 'to'])

export function toTitleCase(s: string): string {
  return s.split(' ').map((w, i) => {
    if (i > 0 && SMALL_WORDS.has(w.toLowerCase())) return w.toLowerCase()
    return w.charAt(0).toUpperCase() + w.slice(1)
  }).join(' ')
}

/** Convert a slug like 'greater-london' to 'Greater London'. */
export function slugToLabel(slug: string | undefined): string {
  return toTitleCase((slug ?? '').replace(/-/g, ' '))
}
